<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.PACKAGENAME"
        nolabel
        :placeholder="$t('search.packagename')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        PACKAGENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        PACKAGENAME: null,
      };
    },
  },
};
</script>

<style></style>
